import React, { } from 'react';
import { useProductStore } from '../../hooks/product';
import { isString } from "underscore";
import { useProductFilterStore } from 'src/hooks/productFilter';
import Helper from 'src/helper/Helper';
import FadeInOut from 'src/component/Global/FadeInOut';
import System from 'src/helper/system';
let c = System.getParams();

const ActiveFilter = (props) => {
    const [{ productListWithFacet }, { }, { }, { }] = useProductStore();
    const [{ filterList }, { get_category_filter_detected }, { clear_product_filter, clear_all_product_filter, clear_product_filter_by_key }, { }] = useProductFilterStore();
    const { translation:t } = System;

    const listMaker = (v, i, slug) => {
        return (
            <React.Fragment key={i}>
                {v.value && isString(v.value) &&
                    <span className="button-white button-small">
                        <span tabIndex={-1} className="filter-item">
                            {v.value}
                        </span>
                        <a onClick={async () => {
                            if (slug == "Categories") {
                                clear_all_product_filter()
                            } else {
                                await clear_product_filter({
                                    key: slug,
                                    selectionIndex: i,
                                })
                            }

                        }}>
                            <i className="fa fa-times" />
                            <span className="sr-only">{t('removeFilter')}</span>
                        </a>
                    </span>
                }
            </React.Fragment>
        );
    };

    const getFilterTitle = (title) => {
        let filterText = '';
        switch (title.toLowerCase()) {
            case 'categories': filterText = t('category'); break;
            case 'family name': filterText = t('productFamily'); break;
            case 'manufacturer name': filterText = t('manufacturer'); break;
            default: filterText = title; break;
        }
        return filterText;
    }

    return (
        <>
            <FadeInOut show={true} duration={300} className="filter-records">
                {productListWithFacet ?
                    <>
                        <span>{t('showing')} <b>{productListWithFacet?.productCount ? productListWithFacet?.productCount : 0}</b> {productListWithFacet?.productCount === 1 ? t('product').toLowerCase() : t('products').toLowerCase()} </span>
                    </> : ""
                }
                <button className={get_category_filter_detected() ? "bs5 btn btn-secondary ms-auto" : "bs5 btn btn-secondary ms-auto d-none"}
                    onClick={() => {
                        props.openFilterBoxSettings()
                    }}
                >{t('addFilters')}
                </button>
            </FadeInOut>
            {filterList &&
                Object.entries(filterList).length > 0 &&
                <>
                    <div className="applied-filters-wrapper">
                        <div className="applied-filters">
                            <span className="applied-filters-inner">
                                <div className="filter-controls">
                                    <div><strong>{t('filters')}</strong></div>
                                    <button className="bs5 btn btn-secondary ms-auto filter-brdcrumb-clear"
                                        data-di-id="di-id-3a31eb8d-378bc1a3"
                                        onClick={() => {
                                            clear_all_product_filter()
                                        }}
                                    >{t('clearAll')}</button>
                                </div>
                                <div className="filters-breadcrumb">
                                    {Object.entries(filterList).map((v, i) => (

                                        filterList[v[0]] &&
                                        <div className="filter-group" key={i}>
                                            <div className="filter-group-title">
                                                <span tabIndex={-1} className="filter-name noSelect">
                                                    {filterList[v[0]].main_label ? getFilterTitle(filterList[v[0]].main_label) : ''}</span>
                                                <button className="remove-filter-group" name="categoryId" data-di-id="di-id-a9fb693c-94d7a22"
                                                    onClick={async () => {
                                                        if (v[0] == "Categories") {
                                                            clear_all_product_filter()
                                                        } else {
                                                            await clear_product_filter_by_key({
                                                                key: v[0]
                                                            })
                                                        }

                                                    }}
                                                >
                                                    <i className="fa fa-times" />
                                                    <span className="sr-only">{t('removeFilter')}</span>
                                                </button>
                                            </div>
                                            <div className="group-filters">
                                                <div className="group-filter-item">
                                                    <div className="group-filter-item">
                                                        {filterList[v[0]].s && filterList[v[0]].s.length > 0 &&
                                                            filterList[v[0]].s.map((p, i) => (
                                                                <React.Fragment key={Helper.UUID()}>
                                                                    {listMaker(p, i, v[0])}
                                                                </React.Fragment>
                                                            ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                    }
                                </div>
                            </span>
                        </div>
                    </div>
                </>
            }
        </>
    );
}

export default ActiveFilter;